import moment from 'moment-jalaali';

export {
  // eslint-disable-next-line
  dateFormatFrom as dateFormat,
  translateDate,
  format,
  createRangeUntilNow,
};

/**
 * Date Formatter
 *
 * Accepts a string as the parsing format
 * returns a function that accepts a string as the date formatter
 *
 * @param fromFormat the parsing format
 * @returns {dateFormatTo}
 */
function dateFormatFrom(fromFormat = 'YYYY-MM-DD HH:mm:ss') {
  return function dateFormatTo(toFormat = 'DD/MM/YYYY HH:mm:ss') {
    return function dateFormat(date) {
      return format(date, toFormat, fromFormat);
    };
  };
}

/**
 * Format
 *
 * Formats the given date using parsing and transforming formats
 * @param date
 * @param toFormat the transforming format
 * @param fromFormat the parsing format
 * @returns {string}
 */
function format(date, toFormat, fromFormat) {
  return moment(date, fromFormat).format(toFormat);
}

function translateDate(date, lang) {
  const toFormat = lang === 'fa' ? 'jYYYY/jMM/jDD' : 'DD/MM/YYYY';
  return dateFormatFrom('YYYY/M/D')(toFormat)(date);
}

function createRangeUntilNow(len, type, format) {
  const now = moment();
  const startingDate = moment().subtract(len, type);

  if (format) {
    return [startingDate.format(format), now.format(format)];
  }

  return [startingDate, now];
}
